$(document).ready(function() {
	$(".js-modal-button").on("click", function(e) {
		e.preventDefault();
		$(".js-modal[data-modal=" + $(this).attr("data-modal") + "]").addClass("active");
		$("body").addClass("fixed-position-modal");
	});
	$(".js-modal").on("click", function(e) {
		if (!((e.target).closest(".js-modal-content"))) {
			$(".js-modal").removeClass("active");
			$("body").removeClass("fixed-position-modal");
		}
	});
	$(".js-modal-close").on("click", function() {
		$(".js-modal").removeClass("active");
		$("body").removeClass("fixed-position-modal");
	});
});


// WEBPACK FOOTER //
// ./src/js/general/modal.js